import React from "react";
import PropTypes from "prop-types";

class ChangeAbstract extends React.Component {
  static UNIT_PERCENT = "%";
  static UNIT_EMPTY = "";

  static propTypes = {
    change: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    unit: PropTypes.string
  };

  static defaultProps = {
    unit: ChangeAbstract.UNIT_PERCENT
  };

  getChange() {
    const { change, unit } = this.props;

    if (typeof change === "undefined" || change === null) {
      return null;
    }

    switch (unit) {
      case ChangeAbstract.UNIT_EMPTY:
        return Number(change).toFixed(2);

      case ChangeAbstract.UNIT_PERCENT:
      default:
        let newChange = Number(change) * 100;
        return newChange.toFixed(2);
    }
  }

  getChangeRate() {
    let change = this.getChange();

    if (!change) {
      return null;
    }

    if (change > 0) {
      return 1;
    } else if (change < 0) {
      return -1;
    }
    return 0;
  }
}

export default ChangeAbstract;
